import { Box, Typography } from '@mui/material';
import parse from 'html-react-parser';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { defaultMessageHeight, notificationCardClass, notificationCardTextClass, notificationColors, } from '../../constants';
import { useNotificationsContext } from '../../hooks/contexts/useNotificationsContext';
import { NotificationCardFooter } from '../notification-card-footer';
import { NotificationCardHeader } from '../notification-card-header';
var useSxStyles = function (_a) {
    var open = _a.open, viewed = _a.viewed;
    var card = notificationColors.card;
    return {
        paperContainer: {
            borderRadius: 4,
        },
        card: {
            borderRadius: '4px',
            marginTop: function (theme) { return theme.spacing(1.5); },
            padding: function (theme) { return theme.spacing(1.5); },
            background: viewed ? card.background : card.hover,
            boxShadow: 'none',
            position: 'relative',
            '&:hover': {
                background: card.hover,
            },
        },
        message: {
            display: open ? "block" : '-webkit-box',
            '-webkit-box-orient': 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: '12px',
            whiteSpace: 'normal',
            '-webkit-line-clamp': open ? 'none' : 2,
            height: open ? 'auto' : "".concat(defaultMessageHeight, "px"),
            lineHeight: "".concat(defaultMessageHeight, "px"),
            transition: function (theme) {
                return theme.transitions.create('height', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.enteringScreen,
                });
            },
            fontWeight: 500,
        },
        elementWrapper: {
            paddingBottom: function (theme) { return theme.spacing(0.5); },
        },
    };
};
export var NotificationCard = function (props) {
    var notification = props.notification;
    var subjectMessage = notification.subjectMessage, bodyMessage = notification.bodyMessage, viewed = notification.viewed, created = notification.created, id = notification.id;
    var formatMessage = useIntl().formatMessage;
    var toggleViewed = useNotificationsContext().toggleViewed;
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var _b = useState(false), needSubjectCollapse = _b[0], setNeedSubjectCollapse = _b[1];
    var _c = useState(false), needMessageCollapse = _c[0], setNeedMessageCollapse = _c[1];
    var sx = useSxStyles({ open: isOpen, viewed: viewed });
    var bodyMessageRef = useRef(null);
    useEffect(function () {
        if (bodyMessageRef.current) {
            var _a = bodyMessageRef.current, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
            setNeedMessageCollapse(scrollHeight !== clientHeight);
        }
    }, [bodyMessageRef, setNeedMessageCollapse]);
    var toggleMessage = useCallback(function () {
        setIsOpen(function (open) { return !open; });
        if (!isOpen && !viewed) {
            toggleViewed(id, true);
        }
    }, [id, isOpen, viewed, setIsOpen, toggleViewed]);
    var parsedBodyMessage = useMemo(function () { return parse(bodyMessage); }, [bodyMessage]);
    var parsedSubjectMessage = useMemo(function () {
        return parse(subjectMessage || formatMessage({ id: 'notification.noSubject', defaultMessage: 'Без темы' }));
    }, [subjectMessage, formatMessage]);
    var isNeedCollapse = needMessageCollapse || needSubjectCollapse;
    return (React.createElement(Box, { sx: sx.card, className: notificationCardClass },
        React.createElement(Box, { sx: sx.elementWrapper },
            React.createElement(NotificationCardHeader, { subjectMessage: parsedSubjectMessage, viewed: viewed, isOpen: isOpen, id: id, setNeedSubjectCollapse: setNeedSubjectCollapse })),
        React.createElement(Box, { sx: sx.elementWrapper },
            React.createElement(Typography, { ref: bodyMessageRef, variant: "body2", className: notificationCardTextClass, sx: sx.message }, parsedBodyMessage)),
        React.createElement(NotificationCardFooter, { isOpen: isOpen, needCollapse: isNeedCollapse, toggleMessage: toggleMessage, created: created })));
};
